import { render, staticRenderFns } from "./ToVerificationContentBasicInformation.vue?vue&type=template&id=15931505&scoped=true&"
import script from "./ToVerificationContentBasicInformation.vue?vue&type=script&lang=js&"
export * from "./ToVerificationContentBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./ToVerificationContentBasicInformation.vue?vue&type=style&index=0&id=15931505&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15931505",
  null
  
)

export default component.exports